import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "./index.css";
import i18n from "./i18n"; // Bilingual EN/AR — remove this line to roll back i18n
import { CookieBanner } from "./components/app/CookieBanner";
import LandingPage from "./pages/LandingPage";

// Observability + support widget + dogfood analytics — all no-op when env
// vars are unset, so this is safe to call unconditionally.
void Promise.all([
  import("./lib/sentry"),
  import("./lib/crisp"),
  import("./lib/ryze-pixel"),
]).then(([{ initSentry }, { initCrisp }, { initRyzePixel }]) => {
  initSentry();
  initCrisp();
  initRyzePixel();
});

const marketingApp = (
  <StrictMode>
    <CookieBanner />
    <LandingPage />
  </StrictMode>
);

const root = document.getElementById("root")!;
const canHydrateLanding =
  window.location.pathname === '/' &&
  root.hasChildNodes() &&
  (i18n.resolvedLanguage ?? i18n.language).startsWith('en');

if (window.location.pathname === '/') {
  if (canHydrateLanding) {
    hydrateRoot(root, marketingApp);
  } else {
    createRoot(root).render(marketingApp);
  }
} else {
  void Promise.all([
    import('@tanstack/react-query'),
    import('./App.tsx'),
  ]).then(([{ QueryClient, QueryClientProvider }, { default: App }]) => {
    const queryClient = new QueryClient({
      defaultOptions: {
        queries: {
          staleTime: 5 * 60 * 1000,
          retry: 1,
        },
      },
    });

    createRoot(root).render(
      <StrictMode>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </StrictMode>,
    );
  });
}
